import { api } from './client'

// Generalized protocol-step authored text. Backs the inline Submit
// buttons on Protocol.jsx (intention, priority, brain dump, progress
// check) and the morning resurface on CheckIn.jsx.
export const protocolInputsApi = {
  // POST is now an upsert server-side keyed on (user, protocol, step,
  // step_type, date) — a second call with the same keys on the same
  // day updates the existing row instead of creating a duplicate.
  // Callers still include ``date: localDateKey()`` so the bucket is
  // the user's local calendar day, not UTC.
  create: (payload, token) => api.post('/protocol-inputs', payload, token),

  // Fetch all authored inputs the current user has saved for the given
  // protocol on the given date. Returns an array — empty when the user
  // has not yet authored anything today. Protocol.jsx uses this on
  // mount to hydrate stepSaved + stepInputs so refresh lands on locked
  // rows with text preserved.
  listForDay: (protocolId, date, token) => {
    let path = `/protocol-inputs?protocol_id=${encodeURIComponent(protocolId)}`
    if (date) path += `&target_date=${date}`
    return api.get(path, token)
  },

  recent: (stepType, token) =>
    api.get(`/protocol-inputs/recent?step_type=${encodeURIComponent(stepType)}`, token),
}
